<ul class="pnl-details-container">
  @if (lounge.lounge.name) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_name">Name:</span>
      <span [innerHTML]="lounge.lounge.name"></span>
    </li>
  }

  @if (lounge.lounge.telephone) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_telephone">Telephone:</span>
      <span [innerHTML]="lounge.lounge.telephone"></span>
    </li>
  }

  @if (lounge.lounge.introduction) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_Introduction">Introduction:</span>
      <span [innerHTML]="lounge.lounge.introduction"></span>
    </li>
  }
  @if (lounge.lounge.misc.covidCopy) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_Infomation">Covid Information:</span>
      <span [innerHTML]="lounge.lounge.misc.covidCopy"></span>
    </li>
  }
  @if (lounge.lounge.misc.importantInformation) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_ImportantInfo">Important Informaiton:</span>
      <span [innerHTML]="lounge.lounge.misc.importantInformation"></span>
    </li>
  }

  @if (lounge.lounge.cancellationInfo) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_cancellation">Cancellation Information:</span>
      <span [innerHTML]="lounge.lounge.cancellationInfo"></span>
    </li>
  }
  @if (lounge.lounge.amendmentsInfo) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_admendments">Amendments Information:</span>
      <span [innerHTML]="lounge.lounge.amendmentsInfo"></span>
    </li>
  }
  @if (lounge.lounge.checkInInfo) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_checkin">Check-in Information:</span>
      <span [innerHTML]="lounge.lounge.checkInInfo"></span>
    </li>
  }
  @if (lounge.lounge.misc.businessfacilities) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_bissFac">Business Facilities:</span>
      <span [innerHTML]="lounge.lounge.misc.businessfacilities"></span>
    </li>
  }
  @if (lounge.lounge.misc.facilitiesdisabled) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_diabledFac">Disabled Facilities:</span>
      <span [innerHTML]="lounge.lounge.misc.facilitiesdisabled"></span>
    </li>
  }
  @if (lounge.lounge.openTime) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_times">Times:</span>
      <span>
        Opens: <span [innerHTML]="lounge.lounge.openTime"></span> Closes:<span
          [innerHTML]="lounge.lounge.closeTime"
        ></span>
      </span>
    </li>
  }
  @if (lounge.lounge.groupInfo) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_groups">Groups:</span>
      <span [innerHTML]="lounge.lounge.groupInfo"></span>
    </li>
  }
  @if (lounge.lounge.dressCode) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_dresscode">Dress Code:</span>
      <span [innerHTML]="lounge.lounge.dressCode"></span>
    </li>
  }
  @if (lounge.lounge.foodAndBeverage) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_foodAndBeverage">Food And Beverage:</span>
      <span [innerHTML]="lounge.lounge.foodAndBeverage"></span>
    </li>
  }
  @if (lounge.lounge.whatsIncludedFood) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_includeFood">Food Included:</span>
      <span [innerHTML]="lounge.lounge.whatsIncludedFood"></span>
    </li>
  }
  @if (lounge.lounge.whatsIncludedDrinks) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_includedDrink">Drinks Included:</span>
      <span [innerHTML]="lounge.lounge.whatsIncludedDrinks"></span>
    </li>
  }
  @if (lounge.lounge.whatsIncludedExtras) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_includedExtras">Extras Included:</span>
      <span [innerHTML]="lounge.lounge.whatsIncludedExtras"></span>
    </li>
  }
  @if (lounge.lounge.groupInfo) {
    <li>
      <span class="light-fat" i18n="@@loungedetails_groupInfo">Group Info:</span>
      <span [innerHTML]="lounge.lounge.groupInfo"></span>
    </li>
  }
</ul>
